import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleConsultation = () => {
    scrollToSection('contact');
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'py-2' : 'py-4'
        }`}
      >
        <nav
          className={`max-w-7xl mx-auto transition-all duration-300 ${
            isMobileMenuOpen 
              ? 'bg-white backdrop-blur-md border border-[var(--border-light)] rounded-2xl shadow-lg mx-4'
              : isScrolled
              ? 'bg-white/60 backdrop-blur-md border border-[var(--border-light)] rounded-full shadow-sm mx-4'
              : 'bg-white/80 backdrop-blur-md border border-[var(--border-light)] rounded-full mx-4 md:mx-6'
          }`}
        >
          <div className="flex items-center justify-between h-14 px-4">
            {/* Logo */}
            <div className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_froma-web-launch/artifacts/8qo2y4tt_1000120027-removebg-preview.png"
                alt="Froma Web"
                className="h-10 w-auto"
              />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-1">
              <button
                onClick={() => scrollToSection('home')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('why-choose')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Why Us
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Process
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Reviews
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-full transition-all duration-200 font-medium"
              >
                Contact
              </button>
            </div>

            {/* CTA Button */}
            <div className="hidden md:block">
              <button onClick={handleConsultation} className="btn-primary">
                Get Free Consultation
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-[var(--text-primary)]"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden py-4 px-4 border-t border-[var(--border-light)] mt-2">
              <div className="flex flex-col space-y-2">
                <button
                  onClick={() => scrollToSection('home')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Home
                </button>
                <button
                  onClick={() => scrollToSection('services')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Services
                </button>
                <button
                  onClick={() => scrollToSection('why-choose')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Why Us
                </button>
                <button
                  onClick={() => scrollToSection('process')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Process
                </button>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Pricing
                </button>
                <button
                  onClick={() => scrollToSection('reviews')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Reviews
                </button>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="px-4 py-3 text-[var(--text-body)] hover:text-[var(--text-primary)] hover:bg-[rgba(0,0,0,0.05)] rounded-lg transition-all duration-200 text-left font-medium"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Contact
                </button>
                <button onClick={handleConsultation} className="btn-primary w-full mt-4">
                  Get Free Consultation
                </button>
              </div>
            </div>
          )}
        </nav>
      </header>
    </>
  );
};

export default Header;
